/*
Use this file to import custom js files from assets-extend/js or npm packages

Example:
import "./js/navigation-desktop.js";
*/

import "./homepage-blocks.js";
import "./klaviyo-popup.js";

(function () {
  var viewportHeight = window.innerHeight;
  document.documentElement.style.setProperty(
    "--initial-viewport-height",
    viewportHeight + "px"
  );
})();

document.addEventListener("DOMContentLoaded", () => {
  const headerGroupHeights = [];
  document
    .querySelectorAll(".shopify-section-group-header-group")
    .forEach((headerGroupSectionEl) => {
      headerGroupHeights.push(
        headerGroupSectionEl.getBoundingClientRect().height
      );
    });

  document.documentElement.style.setProperty(
    "--initial-header-height",
    `${headerGroupHeights.reduce((subtotal, a) => subtotal + a, 0)}px`
  );
});
